import apiClient from '../apiClient';
import { GET_RESTAURANT_BY_PROFILE_ID_URL } from '../apiUrl';

const getRestaurantByProfileIdApi = Id => {
  return apiClient.get(GET_RESTAURANT_BY_PROFILE_ID_URL(Id));
};

export default getRestaurantByProfileIdApi;
